import { Component, Vue } from 'vue-property-decorator';
import WithRender from './productreport.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import { mapGetters } from 'vuex';

@WithRender
@Component({
  filters: {
    formateDate(value: string) {
      return moment(value).format('YYYY-MM-DD HH:mm A')
    }
  },
  components: {
    Loading,
    Datepicker
  },
  computed: {
    ...mapGetters("originatorStore", { currency: "getWalletCurrency" }),
  }
})
export default class productreport extends Vue {
  currency!: string;
  isLoading = false;
  fromDate = new Date();
  toDate = new Date();
  product = "";
  accountNo = '';
  merchantReference = '';
  reference = '';
  readbleStateValue = '';
  readbleStateOptions = [
    { value: '', text: 'All' },
    { value: 'Initialised', text: 'Initialised' },
    { value: 'Pending', text: 'Pending' },
    { value: 'Success', text: 'Success' },
    { value: 'Failed', text: 'Failed' },
    { value: 'Refunded', text: 'Refunded' }
  ]

  perPage = 10;
  currentPage = 1;
  selectedPage = 1;
  totalRecords = 0;

  items = [];
  fields = [
    {
      key: "product",
      label: "Product",
      sortable: true,
    },
    {
      key: "amount",
      label: "Amount",
      sortable: true,
    },
    {
      key: "discount",
      label: "Discount",
      sortable: true,
    },
    {
      key: "transaction",
      label: "Transaction",
      sortable: true,
    }
  ]
  customFormatter(date: Date) {
    return moment(date).format('yyyy-MM-DD');
  }

  customFormatterWithTime(date: Date) {
    return moment(date).format('yyyy-MM-DD HH:mm:ss');
  }
  mounted() {
    this.getReport();
  }

  badgeVarient(value: string): string {
    if (value == "Success")
      return "success";
    if (value == "Pending")
      return "info";
    if (value == "Failed" || value =="Refunded")
      return "danger";
    return "secondary";
  }

  handlePageClick() {
    if (this.currentPage === this.selectedPage)
      return;
    this.currentPage = this.selectedPage;
    this.getReport()
  }

  getReport(): void {
    this.isLoading = true;
    _axios.get(`${config.gateway}admin/report/productReport?&currentPage=${this.currentPage}
    &PageSize=${this.perPage}
    &DateFrom=${this.customFormatter(this.fromDate)}
    &DateTo=${this.customFormatter(this.toDate)}`)
      .then(response => {
        console.log(this.items);
        this.items = response.data.objectList;
        this.totalRecords = response.data.totalRowCount;
      })
      .catch(err => { console.error(err); })
      .finally(() => {
        this.isLoading = false;
      });
  }

  printReport(): void {
    this.isLoading = true;
    _axios.get(`${config.gateway}admin/report/productReport/GetCsv?
    &DateFrom=${this.customFormatter(this.fromDate)}
    &DateTo=${this.customFormatter(this.toDate)}`)
      .then(response => {
        console.log(response.data);
        this.downloadFile(response.data[0].downloadPath,response.data[0].fileName)
        //this.items = response.data;
      })
      .catch(err => { console.error(err); })
      .finally(() => {
        this.isLoading = false;
      });
  }

  downloadFile(fileUrl: string, fileName:string): void {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
